/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponseData;

  constructor(
    err: DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse";
  }
}

/** @internal */
export const DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$inboundSchema:
  z.ZodType<
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse(
        v,
      );
    });

/** @internal */
export type DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$outboundSchema:
  z.ZodType<
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$Outbound,
    z.ZodTypeDef,
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse
  > = z.instanceof(
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$ {
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$inboundSchema;
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$outboundSchema;
  /** @deprecated use `DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$Outbound` instead. */
  export type Outbound =
    DeleteApiWorkspaceServiceV1WorkspaceSharingsSharingIdErrorResponse$Outbound;
}
